/**
 * `itemSpecs.*` wire contract (garment fabric attributes). Behind
 * `entitledProcedureFor("garment.materials")`.
 */
import { z } from "zod";
import { uuid } from "../_common.js";

export const specView = z.object({
  itemId: uuid,
  gsm: z.number().int().nullable(),
  composition: z.string().nullable(),
  widthCm: z.number().int().nullable(),
  colour: z.string().nullable(),
  colourHex: z.string().nullable(),
  shrinkageBp: z.number().int().nullable(),
});

export const getInput = z.object({ itemId: uuid });
export const getOutput = specView.nullable();

export const upsertInput = z.object({
  itemId: uuid,
  gsm: z.number().int().min(0).max(2000).nullable().optional(),
  composition: z.string().trim().max(120).nullable().optional(),
  widthCm: z.number().int().min(0).max(1000).nullable().optional(),
  colour: z.string().trim().max(48).nullable().optional(),
  colourHex: z.string().trim().max(9).nullable().optional(),
  shrinkageBp: z.number().int().min(0).max(10000).nullable().optional(),
});
export const upsertOutput = specView;

export type ItemSpecWire = z.infer<typeof specView>;
